<template>
    <div class="grid">
        <Toast/>
        <div class="col-12" style="max-width: 950px;">
            <div class="card">
                <h4>Balance General
                    <Tag v-if="mode" class="ml-2" :severity="mode === 'LIVE' ? 'success' : 'info'"
                         :value="mode === 'LIVE' ? 'OFICIAL' : 'VALIDACIÓN'"/>
                </h4>
                <div class="formgroup-inline">
                    <div class="field">
                        <label style="width: 90px;">A la fecha</label>
                        <Calendar :showIcon="true" v-model="asOfDate" dateFormat="yy-mm-dd"/>
                    </div>
                    <Button label="Consultar" icon="pi pi-search" class="p-button-success mb-2"
                            :loading="loading" @click="load"/>
                </div>
            </div>
        </div>

        <div class="col-12" style="max-width: 950px;" v-if="report">
            <div class="card">
                <h5>Activos <small style="color:#777;">(lo que tengo y lo que me deben)</small></h5>
                <DataTable :value="report.assets" class="mb-2">
                    <Column field="code" header="Código" style="width: 120px;"></Column>
                    <Column header="Cuenta">
                        <template #body="slotProps">
                            <span :style="rowStyle(slotProps.data)">{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column header="Monto" style="width: 140px;">
                        <template #body="slotProps">${{ money(slotProps.data.amount) }}</template>
                    </Column>
                </DataTable>
                <div style="display: flex; justify-content: flex-end;"><h6><b>Total activos: ${{ money(report.totalAssets) }}</b></h6></div>

                <h5 class="mt-3">Pasivos <small style="color:#777;">(lo que debo)</small></h5>
                <DataTable :value="report.liabilities" class="mb-2">
                    <Column field="code" header="Código" style="width: 120px;"></Column>
                    <Column header="Cuenta">
                        <template #body="slotProps">
                            <span :style="rowStyle(slotProps.data)">{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column header="Monto" style="width: 140px;">
                        <template #body="slotProps">${{ money(slotProps.data.amount) }}</template>
                    </Column>
                </DataTable>
                <div style="display: flex; justify-content: flex-end;"><h6><b>Total pasivos: ${{ money(report.totalLiabilities) }}</b></h6></div>

                <h5 class="mt-3">Patrimonio</h5>
                <DataTable :value="report.equity" class="mb-2" v-if="report.equity.length">
                    <Column field="code" header="Código" style="width: 120px;"></Column>
                    <Column header="Cuenta">
                        <template #body="slotProps">
                            <span :style="rowStyle(slotProps.data)">{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column header="Monto" style="width: 140px;">
                        <template #body="slotProps">${{ money(slotProps.data.amount) }}</template>
                    </Column>
                </DataTable>
                <div style="display: flex; justify-content: flex-end; flex-direction: column; align-items: flex-end;">
                    <h6 style="margin: 2px;">Utilidad del ejercicio: <b>${{ money(report.netIncome) }}</b></h6>
                    <h6 style="margin: 2px;"><b>Total patrimonio: ${{ money(report.totalEquity) }}</b></h6>
                </div>

                <Divider/>
                <Message :severity="report.balanced ? 'success' : 'error'" :closable="false">
                    <span v-if="report.balanced">
                        El balance cuadra: Activos (${{ money(report.totalAssets) }}) = Pasivos (${{ money(report.totalLiabilities) }}) + Patrimonio (${{ money(report.totalEquity) }})
                    </span>
                    <span v-else>
                        El balance NO cuadra — revisa la salud del módulo en Balance de Comprobación.
                    </span>
                </Message>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '../../../service/httpRequest';
import { localISODate } from '../../../service/dates';

export default {
    data() {
        return {
            loading: false,
            asOfDate: new Date(),
            report: null,
            mode: null,
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        rowStyle(row) {
            // Las filas de GRUPO (roll-up, V2-12) son subtotales de lectura: se
            // indentan por nivel y van en negrita para no confundirlas con las
            // cuentas que sí reciben asientos. El total no las suma.
            const indent = (row.level || 0) * 14;
            return 'padding-left:' + indent + 'px;' + (row.isParent ? ' font-weight:700;' : '');
        },
        money(value) {
            return Number(value || 0).toFixed(2);
        },
        async load() {
            this.loading = true;
            const asOf = localISODate(this.asOfDate);   // fecha local, no UTC (H64)
            const response = await httpRequest.getAccountingBalanceSheet(asOf);
            this.loading = false;
            if (response.status === 200) {
                this.report = response.data;
                this.mode = response.data.mode;
            } else {
                this.$toast.add({severity: 'warn', summary: 'Contabilidad', detail: response.error || 'No se pudo consultar el reporte', life: 4000});
            }
        },
    },
}
</script>
